"use client";

import React, { useState } from 'react';
import { ShareIconBordered } from 'components/icons/v2/ShareIconBordered';
import { Button } from 'components/ui/button';
import { MEMBER_ROUTES } from 'utils/routes';

interface ShareButtonProps {
  subdomain: string;
  className?: string;
}

export const ShareButton: React.FC<ShareButtonProps> = ({ subdomain, className = '' }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    const baseUrl = window.location.origin;
    
    const urlToCopy = `${baseUrl}${MEMBER_ROUTES.SPACE.getPath(subdomain)}`;
    
    try {
      await navigator.clipboard.writeText(urlToCopy);
    } catch (err) {
      console.error('Failed to copy URL: ', err);
    }
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <Button
      variant={'nakedGrayLink'}
      className={`text-small pl-0 relative ${className}`}
      onClick={handleCopy}
    >
      <ShareIconBordered className={'mr-1'} />
      <div className="relative h-[24px] w-[60px] overflow-hidden flex items-center">
        <span className={`absolute flex items-center transition-transform duration-300 ${
          isCopied ? 'transform -translate-y-full' : 'transform translate-y-0'
        }`}>
          Share
        </span>
        <span className={`absolute flex items-center transition-transform duration-300 ${
          isCopied ? 'transform translate-y-0' : 'transform translate-y-full'
        }`}>
          Copied!
        </span>
      </div>
    </Button>
  );
};

export default ShareButton;